import { InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { DeploymentSettings, DesignBm } from '@cue/api';

export type NavigationSettings = {
  design: DesignBm;
  deploymentSettings?: DeploymentSettings;
  url?: string;
  companyLogoUrl?: string;
  navigationAppEnabled: boolean | null;
  enableReservations: boolean;
  enableStepNavigation: boolean;
  gpsInfo: boolean;
};

export const NAVIGATION_SETTINGS = new InjectionToken<NavigationSettings>('CUE_NAVIGATION_SETTINGS');

export function provideNavigationSettings(opt: { configurationFactory: () => NavigationSettings }) {
  return makeEnvironmentProviders([
    {
      provide: NAVIGATION_SETTINGS,
      useFactory: opt.configurationFactory,
      multi: false,
    },
  ]);
}
